import React from "react";
import OldOrderItem from "./OldOrderItem";
import { useAppSelector } from "../../store";
import { Order } from "../../store/slices/order/types";
import { EmptyResult } from "../organisation";

const OldOrders = ({
  setShowResult,
  setSelectedOrder,
}: {
  setShowResult: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedOrder: React.Dispatch<React.SetStateAction<Order | null>>;
}) => {
  const { dashboardInfo } = useAppSelector(
    (state) => state.organisationReducer
  );

  return (
    <div className="bg-[#F2F6FA] border-[1px] border-[#E5E9F2] rounded-[1rem] py-8 px-4 lg:px-6">
      <div>
        {dashboardInfo?.oldOrders &&
        dashboardInfo?.oldOrders.length > 0 ? (
          dashboardInfo?.oldOrders
            .slice()
            .sort(
              (a, b) =>
                new Date(b.createdAt).getTime() -
                new Date(a.createdAt).getTime()
            )
            .map((order) => (
              <OldOrderItem
                key={order?._id}
                oldOrder={order}
                setShowResult={setShowResult}
                setSelectedOrder={setSelectedOrder}
              />
            ))
        ) : (
          <>
            <EmptyResult />
          </>
        )}
      </div>
    </div>
  );
};

export default OldOrders;
